import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_4: FaireProductEntity = {
  token: "fable-home-4",
  type: "product",
  name: "Wooden Serving Board",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9e0eebc904d713721c1368379f59299d59f1be6cb959460630af62e79f3f4887.webp",
  priceDollars: 78,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 2.5,
  dimensions: {
    width: 14,
    height: 20,
    depth: 2,
  },
  description: "Hand-finished wooden charcuterie board.",
  categoryTokens: ["cat_accessories"],
  tags: ["wood", "serving", "kitchen"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
